<template>
  <div class="home">
    <component :is="current"></component>
  </div>
</template>

<script>
import WebCheck from "@/components/WebCheck";
import H5Check from "@/components/H5Check.vue";
import { isPC } from "@/utils";
export default {
  name: "Home",
  components: {
    WebCheck,
    H5Check,
  },

  data() {
    return {
      current: "WebCheck",
    };
  },

  created() {
    this.current = isPC() ? "WebCheck" : "H5Check";
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100%;
}
</style>

